export default __webpack_public_path__ + "static/media/crack2.181f5583.wav";